import { useEffect } from 'react'
import { OnDetail } from '../../types'
import TaxCard from '../TaxInformation/Card'
import { Section } from '../common'
import OwnerCard from './Card'

type Props = {
  loading?: boolean
  property: TopHap.ExtendedProperty
  showOwner?: boolean
  history: TopHap.PropertyTransaction[] | undefined
  onDetail: OnDetail
  ownerInfo: TopHap.PropertyState['ownerInfo']
  getOwnerInfo: () => void
}

const Owner: React.FC<Props> = ({
  loading,
  history,
  ownerInfo,
  property,
  showOwner,
  onDetail,
  getOwnerInfo
}) => {
  useEffect(() => {
    if (showOwner && !ownerInfo) {
      getOwnerInfo()
    }
  }, [showOwner, property.id])

  return (
    <Section
      description='Information about the current owner(s).'
      id='ownership'
      title='Current Ownership'
    >
      <TaxCard
        loading={loading}
        property={property}
        onDetail={history ? onDetail : undefined}
      />
      {showOwner && (
        <OwnerCard
          loading={loading}
          ownerInfo={ownerInfo}
          property={property}
          onDetail={onDetail}
        />
      )}
    </Section>
  )
}

export default Owner
